import { useQuery } from "@apollo/client";
import { getSectionSocialLogoSrc } from "@/assets/images/sections";
import { ProfileSkeleton } from "@/components/Skeleton";
import { SECTION_DETAILS_HEADER_QUERY } from "@/pages/sections/[sectionId]/queries";
import ObjectHeading from "@/components/ObjectHeading";

export interface MobileSectionOverviewProps {
  sectionId: string;
}

export default function MobileSectionOverview({ sectionId }: MobileSectionOverviewProps) {
  const { data, loading, error } = useQuery(SECTION_DETAILS_HEADER_QUERY, {
    variables: { sectionId }
  });

  if (loading) return <ProfileSkeleton />;
  if (error) return <div>Error loading section details</div>;
  if (!data?.section) return <div>Section not found</div>;

  const { section } = data;

  return (
    <div
      className="bg-sys-brand-surface pb-4 border-b border-sys-brand-outline-variant"
      data-testid="mobile-section-overview"
    >
      <ObjectHeading
        title={section.name}
        iconName="domain"
        variant="landing-page"
        logoUrl={getSectionSocialLogoSrc(section.legacyId)}
      />
    </div>
  );
}
